import { render, staticRenderFns } from "./InnerBlock.vue?vue&type=template&id=1c049f5e&"
import script from "./InnerBlock.vue?vue&type=script&lang=js&"
export * from "./InnerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports